export class ReportStatuses {
  static readonly DRAFT = 'Draft';
}
